import React from 'react';
import PropTypes from 'prop-types';
import { mergeClasses } from '@fluentui/react-components';
import { withSiteMap, getRoutePathById } from '@bingads-webui-campaign-react/with-site-map';
import { isAudienceNativeAdsCampaign, isAudienceCTVCampaign, isAudienceDealCampaign } from '@bingads-webui-campaign-react/constants';

import { WIZARD_TYPE_TO_FLOW, WIZARD_TYPES } from '../step-constants';
import { DisplayPlusEditWizard } from './display-plus-edit-wizard';
import { useDisplayPlusEditWizardStyles } from './wizard-styles';

const getWizardType = (currentCampaign) => {
  if (isAudienceNativeAdsCampaign(currentCampaign.CampaignSubType)) {
    return WIZARD_TYPES.AUDIENCE_AD_GROUP_EDIT;
  }

  if (isAudienceCTVCampaign(currentCampaign)) {
    return WIZARD_TYPES.AUDIENCE_AD_GROUP_CTV_EDIT;
  }

  if (isAudienceDealCampaign(currentCampaign)) {
    return WIZARD_TYPES.AUDIENCE_AD_GROUP_DEAL_EDIT;
  }

  return WIZARD_TYPES.AUDIENCE_AD_GROUP_EDIT;
};

const DisplayPlusEditAdGroupWizardInternal = ({
  currentCampaign, currentAdGroup, siteMap, perfMarker,
}) => {
  const styles = useDisplayPlusEditWizardStyles();
  const routeToNavigateToWhenDone = getRoutePathById(siteMap, 'adgroups');

  const wizardType = getWizardType(currentCampaign);
  const flowType = WIZARD_TYPE_TO_FLOW[wizardType];

  return (
    <div className={mergeClasses('display-plus-edit-adgroup-wizard', styles.wizardWrapper)}>
      <DisplayPlusEditWizard
        wizardType={wizardType}
        flowType={flowType}
        routeToNavigateToWhenDone={routeToNavigateToWhenDone}
        initialWizardData={{
          campaign: currentCampaign,
          adGroup: currentAdGroup,
        }}
        perfMarker={perfMarker}
      />
    </div>
  );
};

DisplayPlusEditAdGroupWizardInternal.propTypes = {
  siteMap: PropTypes.shape({}).isRequired,
  scope: PropTypes.shape({
    save: PropTypes.func.isRequired,
  }).isRequired,
  perfMarker: PropTypes.shape({
    createChild: PropTypes.func.isRequired,
  }).isRequired,
  currentCampaign: PropTypes.shape({
    CampaignSubType: PropTypes.number.isRequired,
  }).isRequired,
  currentAdGroup: PropTypes.shape({}).isRequired,
};

export const DisplayPlusEditAdGroupWizard = withSiteMap(DisplayPlusEditAdGroupWizardInternal);
